"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.create.title': 'Utwórz Test Bota',
};
